import { defineStore } from "pinia";
import { login, getProfile, logout } from "@/api/auth";
import { Local } from "@/utils/storage";
import router from "@/router";

export const useUserStore = defineStore("user", {
  state: () => ({
    token: Local.get("token") || "",
    userInfo: Local.get("userInfo") || {},
  }),
  getters: {
    isLoggedIn: (state) => !!state.token,
  },
  actions: {
    async loginAction(loginForm: { username: string; password: string }) {
      try {
        const res: any = await login(loginForm);
        this.token = res.data.token;
        this.userInfo = res.data.userInfo;
        Local.set("token", res.data.token);
        Local.set("userInfo", res.data.userInfo);
        return res;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getUserInfoAction() {
      try {
        const res: any = await getProfile();
        this.userInfo = res.data;
        Local.set("userInfo", res.data);
        return res;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async logoutAction() {
      try {
        await logout();
      } catch (error) {
        console.error(error);
      } finally {
        this.token = "";
        this.userInfo = {};
        Local.remove("token");
        Local.remove("userInfo");
        router.push("/login");
      }
    },
  },
});
